import React from 'react';
import { CHECKOUT_URL } from '../data/config';
interface CtaButtonProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
}
const baseClasses = 'inline-flex items-center justify-center gap-2 rounded-2xl bg-verde px-7 py-4 text-center font-sans text-base font-bold uppercase tracking-wide text-white shadow-[0_12px_28px_-10px_rgba(76,175,80,0.75)] transition-all duration-300 hover:bg-verde-dark hover:-translate-y-0.5 hover:shadow-[0_18px_34px_-12px_rgba(76,175,80,0.85)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-verde sm:text-lg';

/** Botón que abre el checkout (CHECKOUT_URL) en una pestaña nueva. */
export function CheckoutButton({
  children,
  className = '',
  fullWidth = true
}: CtaButtonProps) {
  return <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className={`${baseClasses} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-38" data-mp="19aa15fgaduqz">
      {children}
    </a>;
}
interface ScrollButtonProps extends CtaButtonProps {
  targetId: string;
}

/** Botón que hace scroll suave hasta una sección de la página. */
export function ScrollButton({
  children,
  targetId,
  className = '',
  fullWidth = false
}: ScrollButtonProps) {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    const target = document.getElementById(targetId);
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <a href={`#${targetId}`} onClick={handleClick} className={`${baseClasses} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-39" data-mp="3swasowocu3ct">
      {children}
    </a>;
}